import {Dialog} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import React, {Component} from 'react';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';
import {returnFocus} from '../../../_shared/GWTBridge/invoke/genPage';
import {getTopDialogZindex} from '../../../_shared/GWTBridge/invoke/priModalDlg';
import styles from '../styles/FormHelpDialog.module.scss';
import {getServerTexts} from '../texts';
import {Pages} from '../types';
import {DetailsPage} from './FormHelpPages/DetailsPage';
import {ListPage} from './FormHelpPages/ListPage';
import {MainPage} from './FormHelpPages/MainPage';

const formHelpDialogRef: React.RefObject<any> = React.createRef();
export async function renderFormHelpDialog(root) {
    await getServerTexts();
    root.render(<FormHelpDialog ref={formHelpDialogRef} />);
    return formHelpDialogRef && formHelpDialogRef.current;
}

@observer
export class FormHelpDialog extends Component<any, any> {
    onClose = () => {
        formsStore?.currentForm.helpBook?.setShowHelp(false);
        formsStore?.currentForm.helpBook?.initHelpPageQueue();
        returnFocus();
    };

    renderContent = () => {
        const currentForm = formsStore?.currentForm;
        const {title} = currentForm;
        const {
            helpPageQueue,
            isLoadingHelpData,
            addHelpPage,
            setHelpPageQuery,
            setHelpActiveListPage,
            removeHelpPage,
            formHelp
        } = currentForm.helpBook;

        const {
            page,
            id,
            docType,
            activePage = 1,
            query = ''
        } = helpPageQueue[helpPageQueue.length - 1];

        switch (page) {
            case Pages.main:
                return (
                    <MainPage
                        isLoadingHelpData={isLoadingHelpData}
                        addHelpPage={addHelpPage}
                        setHelpPageQuery={setHelpPageQuery}
                        title={title}
                        isNewApi={!formsStore?.currentForm}
                        query={query}
                        formHelp={formHelp}
                    />
                );
            case Pages.list:
                return (
                    <ListPage
                        docType={docType}
                        activePage={activePage}
                        query={query}
                        title={title}
                        formHelp={formHelp}
                        setHelpActiveListPage={setHelpActiveListPage}
                        setHelpPageQuery={setHelpPageQuery}
                        removeHelpPage={removeHelpPage}
                        addHelpPage={addHelpPage}
                    />
                );
            case Pages.details:
                return <DetailsPage id={id} removeHelpPage={removeHelpPage} />;
            default:
                return null;
        }
    };
    render() {
        const {currentForm} = formsStore;

        if (currentForm?.helpBook?.showHelp) {
            return (
                <Dialog
                    isOpen={currentForm?.helpBook?.showHelp}
                    content={this.renderContent()}
                    componentClasses={styles.formHelpDialg}
                    onClose={this.onClose}
                    mask={false}
                    size="large"
                    draggable
                    zIndex={getTopDialogZindex()}
                />
            );
        }
        return null;
    }
}
